import React from 'react';
import { useTranslation } from 'react-i18next';
import namkeBanner from '../assets/namke-banner.png';

/**
 * Bannière illustrée namke réutilisable pour l'en-tête des pages de contenu.
 * `bare` omet le conteneur max-width/padding, pour une intégration dans un
 * conteneur déjà centré/padded (ex: page traiteur).
 */
const PageBanner = ({ className = '', bare = false }) => {
  const { t } = useTranslation();
  const image = (
    <img
      src={namkeBanner}
      alt={t('pageBanner.alt')}
      className="w-full h-28 sm:h-40 md:h-52 object-cover rounded-2xl"
    />
  );

  if (bare) {
    return <div className={`mb-8 ${className}`}>{image}</div>;
  }

  return (
    <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8 ${className}`}>
      {image}
    </div>
  );
};

export default PageBanner;
